import { render, staticRenderFns } from "./DefectsForm.vue?vue&type=template&id=55c77f08"
import script from "./DefectsForm.vue?vue&type=script&lang=js"
export * from "./DefectsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports